import { render } from "./MainV2.vue?vue&type=template&id=1d0fbfef&scoped=true"
import script from "./MainV2.vue?vue&type=script&lang=js"
export * from "./MainV2.vue?vue&type=script&lang=js"

import "./MainV2.vue?vue&type=style&index=0&id=1d0fbfef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0fbfef"]])

export default __exports__